import React, { Suspense } from 'react';
import { reduxStore } from './store';
import { Provider } from "react-redux";
import { MemoryRouter, Route, Switch } from 'react-router-dom';
import ErrorBoundary from './pages/ErrorBoundary';
import "./assets/styles/material-icons.css";
import "./assets/styles/style.css";
import "./assets/styles/main.css";
import 'react-tabs/style/react-tabs.css';
import "./assets/styles/ketcher.css";
import './assets/styles/print.css';
import Loading from "./Loading";

const Login = React.lazy(() => import("./pages/Login"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const AccountActivate = React.lazy(() => import("./pages/AccountActivate"));
const PageNotFound = React.lazy(() => import("./pages/PageNotFound"));
const TestData = React.lazy(() => import("./pages/TestData"));

/* LEGO */
const Grid = React.lazy(() => import("./pages/Lego/Grid"));
const ReportGrid = React.lazy(() => import("./pages/Lego/ReportGrid"));
const ViewHistory = React.lazy(() => import("./pages/History/ViewHistory"));
const TestTrendReport = React.lazy(() => import("./pages/Lego/TestTrendReport"));

/* ADMINSTRATION */
const CreateSite = React.lazy(() => import("./pages/Adminstration/Site/CreateSite"));
const ViewSite = React.lazy(() => import("./pages/Adminstration/Site/ViewSite"));
const SecuritySettings = React.lazy(() => import("./pages/Adminstration/Settings/SecuritySettings"));
const AppConfigurations = React.lazy(() => import("./pages/Adminstration/Settings/AppSettings"));
const CreateUser = React.lazy(() => import("./pages/Adminstration/IdentityAccess/User/CreateUser"));
const ViewUser = React.lazy(() => import("./pages/Adminstration/IdentityAccess/User/ViewUser"));
const CreateGroup = React.lazy(() => import("./pages/Adminstration/IdentityAccess/Group/CreateGroup"));
const ViewGroup = React.lazy(() => import("./pages/Adminstration/IdentityAccess/Group/ViewGroup"));
const License = React.lazy(() => import("./pages/Adminstration/Licenses/License"));
const CreateUserType = React.lazy(() => import("./pages/Adminstration/IdentityAccess/UserTypes/CreateUserType"));
const ViewUserType = React.lazy(() => import("./pages/Adminstration/IdentityAccess/UserTypes/ViewUserType"));
const CreateRemark = React.lazy(() => import("./pages/Adminstration/Auxiliaries/DefaultRemark/CreateRemark"));
const ViewRemark = React.lazy(() => import("./pages/Adminstration/Auxiliaries/DefaultRemark/ViewRemark"));
const CreateUnit = React.lazy(() => import("./pages/Adminstration/Auxiliaries/UnitMeasurement/CreateUnit"));
const ViewUnit = React.lazy(() => import("./pages/Adminstration/Auxiliaries/UnitMeasurement/ViewUnit"));
const CreateReasonCode = React.lazy(() => import("./pages/Adminstration/Auxiliaries/ReasonCode/CreateReasonCode"));
const ViewReasonCode = React.lazy(() => import("./pages/Adminstration/Auxiliaries/ReasonCode/ViewReasonCode"));
const SignatureConfiguration = React.lazy(() => import("./pages/Adminstration/Signature/SignatureConfiguration"));
const CreateApproval = React.lazy(() => import("./pages/Adminstration/Approval/Create"));
const ViewApproval = React.lazy(() => import("./pages/Adminstration/Approval/View"));
const CreateEmail = React.lazy(() => import("./pages/Adminstration/Email/Create"));
const ViewEmail = React.lazy(() => import("./pages/Adminstration/Email/View"));
const CreateDepartment = React.lazy(() => import("./pages/Adminstration/Department/Create"))
const ViewDepartment = React.lazy(() => import("./pages/Adminstration/Department/View"))
const CreateSharedList = React.lazy(() => import("./pages/Adminstration/SharedList/CreateSharedList"));
const ViewSharedList = React.lazy(() => import("./pages/Adminstration/SharedList/ViewSharedList"));
const CreateCustomFields = React.lazy(() => import("./pages/Adminstration/CustomFields/CreateCustomFields"));
const CustomFieldsTextBox = React.lazy(() => import("./pages/Adminstration/CustomFields/CustomFieldTypes/CustomFieldsTextBox"));
const ViewCustomFields = React.lazy(() => import("./pages/Adminstration/CustomFields/ViewCustomFields"));

/* Template */
const CreateTemplate = React.lazy(() => import("./pages/Templates/TemplateRegistration/Create"));
const ViewTemplate = React.lazy(() => import("./pages/Templates/TemplateRegistration/View"));


/* LDMS */
const CreateDocumentType = React.lazy(() => import("./pages/LDMS/DocumentType/CreateDocumentType"));
const ViewDocumentType = React.lazy(() => import("./pages/LDMS/DocumentType/ViewDocumentType"));
const CreateDocumentUpload = React.lazy(() => import("./pages/LDMS/DocumentUpload/CreateDocumentUpload"));
const ViewDocumentUpload = React.lazy(() => import("./pages/LDMS/DocumentUpload/ViewDocumentUpload"));
const CreateDocumentMapping = React.lazy(() => import("./pages/LDMS/DocumentMapping/CreateDocumentMapping"));
const ViewDocumentMapping = React.lazy(() => import("./pages/LDMS/DocumentMapping/ViewDocumentMapping"));
const CreateDocumentArchival = React.lazy(() => import("./pages/LDMS/DocumentArchival/CreateDocumentArchival"));
const ViewDocumentArchival = React.lazy(() => import("./pages/LDMS/DocumentArchival/ViewDocumentArchival"));

const TokenValidator = React.lazy(() => import("./components/TokenValidator"));
/*Appraisals */
const CreateAppraisalRegistration = React.lazy(() => import("./pages/Appraisals/AppraisalRegistration/Create"));
const ViewAppraisalRegistration = React.lazy(() => import("./pages/Appraisals/AppraisalRegistration/View"));
const CreateAppraisalAssignment = React.lazy(() => import("./pages/Appraisals/AppraisalAssignment/Create"));
const ViewAppraisalAssignment = React.lazy(() => import("./pages/Appraisals/AppraisalAssignment/View"));
const CreateAppraisalSelfAssessment = React.lazy(() => import("./pages/Appraisals/SelfAssessment/Create"));
const ViewAppraisalSelfAssessment = React.lazy(() => import("./pages/Appraisals/SelfAssessment/View"));
const CreateAppraisalSupervisorAssessment = React.lazy(() => import("./pages/Appraisals/SupervisorAssessment/Create"));
const ViewAppraisalSupervisorAssessment = React.lazy(() => import("./pages/Appraisals/SupervisorAssessment/View"));
const ViewAssociateAcknowledgement = React.lazy(() => import("./pages/Appraisals/AssociateAcknowledgement/View"));
const ViewSelfAssessmentReport = React.lazy(() => import("./pages/Appraisals/Reports/ViewReport"));

const App = () => (
  <MemoryRouter>
    <ErrorBoundary>
      <Provider store={reduxStore}>
        <Suspense fallback={<Loading />}>
          <TokenValidator />
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/account-activate" component={AccountActivate} />
            <Route exact path="/logout" component={Login} />
            <Route exact path="/lego/:module_name/:resource_path" component={Grid} />
            <Route exact path="/lego-report-grid/:module_name/:resource_path" component={ReportGrid} />
            <Route exact path="/lego-test-trend-report-grid/:menu_id/:resource_path" component={TestTrendReport} />
            <Route exact path="/v-history/:id/:resource_path/:menu_id" component={ViewHistory} />
            <Route exact path="/test-data" component={TestData} />

            {/* ADMINSTRATION */}
            <Route exact path="/c-sites/:id/:ref" component={CreateSite} />
            <Route exact path="/v-sites/:id/:ref/:action?" component={ViewSite} />
            <Route exact path="/security-settings" component={SecuritySettings} />
            <Route exact path="/security-settings/:id/:ref" component={SecuritySettings} />
            <Route exact path="/app-configs" component={AppConfigurations} />
            <Route exact path="/c-users/:id/:ref" component={CreateUser} />
            <Route exact path="/v-users/:id/:ref/:action?" component={ViewUser} />
            <Route exact path="/c-groups/:id/:ref" component={CreateGroup} />
            <Route exact path="/v-groups/:id/:ref/:action?" component={ViewGroup} />
            <Route exact path="/license" component={License} />
            <Route exact path="/c-user-types/:id/:ref" component={CreateUserType} />
            <Route exact path="/v-user-types/:id/:ref/:action?" component={ViewUserType} />
            <Route exact path="/c-department/:id/:ref" component={CreateDepartment} />
            <Route exact path="/v-department/:id/:ref/:action?" component={ViewDepartment} />
            <Route exact path="/c-default-reasons/:id/:ref" component={CreateRemark} />
            <Route exact path="/v-default-reasons/:id/:ref/:action?" component={ViewRemark} />
            <Route exact path="/c-uom/:id/:ref" component={CreateUnit} />
            <Route exact path="/v-uom/:id/:ref/:action?" component={ViewUnit} />
            <Route exact path="/c-reason-code/:id/:ref" component={CreateReasonCode} />
            <Route exact path="/v-reason-code/:id/:ref/:action?" component={ViewReasonCode} />
            <Route exact path="/e-signature" component={SignatureConfiguration} />
            <Route exact path="/c-approval-config/:id/:ref" component={CreateApproval} />
            <Route exact path="/v-approval-config/:id/:ref/:action?" component={ViewApproval} />
            <Route exact path="/c-e-mail/:id/:ref/:action?" component={CreateEmail} />
            <Route exact path="/v-e-mail/:id/:ref/:action?" component={ViewEmail} />
            <Route exact path="/c-shared-list/:id/:ref" component={CreateSharedList} />
            <Route exact path="/v-shared-list/:id/:ref/:action?" component={ViewSharedList} />
            <Route exact path="/c-custom-fields/:id/:ref" component={CreateCustomFields} />
            <Route exact path="/v-custom-fields/:id/:ref/:action?" component={ViewCustomFields} />
            <Route exact path="/create-custom-text-fields/:id/:ref" component={CustomFieldsTextBox} />

            {/* Template  */}
            <Route exact path="/c-template-registration/:id/:ref" component={CreateTemplate}/>
            <Route exact path="/v-template-registration/:id/:ref/:action?" component={ViewTemplate}/> 
              {/* Appraisals */}
            <Route exact path="/c-appraisal-registration/:id/:ref" component={CreateAppraisalRegistration}/>
            <Route exact path="/v-appraisal-registration/:id/:ref/:action?" component={ViewAppraisalRegistration}/>
            <Route exact path="/c-appraisal-assignment/:id/:ref" component={CreateAppraisalAssignment}/>
            <Route exact path="/v-appraisal-assignment/:id/:ref/:action?" component={ViewAppraisalAssignment}/>
            <Route exact path="/c-self-assessment/:id/:ref" component={CreateAppraisalSelfAssessment}/>
            <Route exact path="/v-self-assessment/:id/:ref/:action?" component={ViewAppraisalSelfAssessment}/>
            <Route exact path="/c-supervisor-assessment/:id/:ref" component={CreateAppraisalSupervisorAssessment}/>
            <Route exact path="/v-supervisor-assessment/:id/:ref/:action?" component={ViewAppraisalSupervisorAssessment}/>
            <Route exact path="/v-associate-acknowledgement/:id/:ref/:action?" component={ViewAssociateAcknowledgement}/>
            <Route exact path ="/v-selfassessment-report/:id/:ref/:action?" component={ViewSelfAssessmentReport} />

            {/* LDMS */}
            <Route exact path="/c-ldms-document-types/:id/:ref" component={CreateDocumentType} />
            <Route exact path="/v-ldms-document-types/:id/:ref/:action?" component={ViewDocumentType} />
            <Route exact path="/c-ldms-document-uploads/:id/:ref" component={CreateDocumentUpload} />
            <Route exact path="/v-ldms-document-uploads/:id/:ref/:action?" component={ViewDocumentUpload} />
            <Route exact path="/c-ldms-document-module-mapping/:id/:ref" component={CreateDocumentMapping} />
            <Route exact path="/v-ldms-document-module-mapping/:id/:ref/:action?" component={ViewDocumentMapping} />
            <Route exact path="/c-ldms-document-archival/:id/:ref" component={CreateDocumentArchival} />
            <Route exact path="/v-ldms-document-archival/:id/:ref/:action?" component={ViewDocumentArchival} />

            <Route component={PageNotFound} />
          </Switch>
        </Suspense>
      </Provider>
    </ErrorBoundary>
  </MemoryRouter >
)

export default App;
